import Heading from '@eduzz/houston-ui/Typography/Heading';
import { Grid, Paper } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import User from 'classes/User';
import React from 'react';
import { connect } from 'react-redux';
import { EProductType } from 'v2/interfaces/product';

import CheckoutBumpHelperText from './CheckoutBumpHelperText';
import Delivery from './Delivery';
import ProductDetails from './ProductDetails';
import ShareableLinks from './ShareableLinks';
import styles from './styles';
import { SolidaritySquadModal } from '../../SolidaritySquad/Modal';

import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';

interface IProps extends StyledComponentProps {
  product: IProduct;
  currentUser: IUser;
}

interface IStates {
  isSolidaritySquadModalOpen: boolean;
}

class Preview extends React.Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSolidaritySquadModalOpen: true,
    };
  }

  handleCloseSolidaritySquadModal = () => {
    this.setState({
      isSolidaritySquadModalOpen: false,
    });
  };

  render() {
    const { product, classes, currentUser } = this.props;
    const { isSolidaritySquadModalOpen } = this.state;

    const productPhysicalAndUserElite = product.type === 3 && currentUser?.is_elite;

    return (
      <>
        <SolidaritySquadModal isOpen={isSolidaritySquadModalOpen} handleClose={this.handleCloseSolidaritySquadModal} productId={product.id} />
        <Paper className={classes.paper}>
          <div className='title'>
            <Heading as='h3' size='md' color='primary'>
              Tudo certo!
            </Heading>
            <Heading as='h3' size='md' color='primary'>
              Produto em moderação. Mas você já pode começar a vender!
            </Heading>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p className='text'>Mais abaixo nesta página, você já consegue ver o seu link de divulgação.</p>
              <p className='text'>
                É importante que o seu Produto esteja dentro das nossas recomendações, assim você evita que as vendas sejam interrompidas pelo nosso
                processo de análise e moderação, ok?{' '}
                <a
                  href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807655450-Como-funciona-a-modera%C3%A7%C3%A3o-de-conte%C3%BAdo-'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Entenda como funciona
                </a>
                .
              </p>
            </Grid>

            <ProductDetails product={product} />
            <Grid item xs={12} md={9}>
              {(product.type !== EProductType.PHYSICAL || productPhysicalAndUserElite) && (
                <ShareableLinks productId={product.id} isWhiteBelt={!currentUser?.is_elite} />
              )}
            </Grid>
            <Grid item xs={12} className='deliver-section'>
              <Delivery product={product} />
            </Grid>
            <Grid>
              <CheckoutBumpHelperText />
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    product: state.components.newProductWizard.product,
    currentUser: new User(state.orbita.User.user),
  };
}

export default styles(connect(mapStateToProps)(Preview));
